import { z } from "zod";
import { ColorTokenData } from "./color";
import {
  DocumentationItemHeaderAlignment,
  DocumentationItemHeaderAlignmentSchema,
  DocumentationItemHeaderImageScaleType,
  DocumentationItemHeaderImageScaleTypeSchema,
} from "./item-header";
import { PageBlockAsset } from "./documentation-block-v1";

//
// Definitions
//

export const DocumentationItemHeaderV1 = z.object({
  description: z.string(),
  alignment: DocumentationItemHeaderAlignmentSchema,
  foregroundColor: ColorTokenData.nullish(),
  backgroundColor: ColorTokenData.nullish(),
  backgroundImageAsset: PageBlockAsset.nullish(),
  backgroundImageScaleType: DocumentationItemHeaderImageScaleTypeSchema,
  showBackgroundOverlay: z.boolean(),
  showCoverText: z.boolean(),
  minHeight: z.number().nullish(),
});

export type DocumentationItemHeaderV1 = z.infer<typeof DocumentationItemHeaderV1>;

export const defaultDocumentationItemHeaderV1: DocumentationItemHeaderV1 = {
  alignment: DocumentationItemHeaderAlignment.Left,
  backgroundImageScaleType: DocumentationItemHeaderImageScaleType.AspectFill,
  description: "",
  showBackgroundOverlay: false,
  showCoverText: true,
};
